import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: "I teach eleven PE classes a week and Sunday nights used to disappear into planning. Now I open the lesson planning module, pick a 45-minute structure, check the setup and I'm done in ten minutes. The activity library alone has replaced about thirty browser tabs.",
  author: 'Mark Ellison',
  role: 'PE Teacher, Secondary School — 14 years teaching',
  location: 'Leeds, United Kingdom'
}, {
  text: 'Our gym is shared with two other programmes, so half my lessons happen in a corridor-sized space or outdoors in the cold. The equipment and space adaptation guide is the piece I use most — same objective, different setup, no scrambling five minutes before the bell.',
  author: 'Danielle Carver',
  role: 'Physical Education Teacher, Grades 4–8 — 9 years teaching',
  location: 'Calgary, Canada'
}, {
  text: 'I came into PE from coaching, so teaching mixed-ability classes of thirty was the hard part, not the sport. The class management toolkit fixed my transitions and waiting time, and the progressions gave me a clear path from simple to challenging for every skill.',
  author: 'Tyler Brooks',
  role: 'High School PE Teacher & Athletics Coach — 6 years teaching',
  location: 'Charlotte, United States'
}, {
  text: 'Assessment was always the part I dragged my feet on. The observation sheets, rubrics and progress trackers were ready to use straight away, and my department head asked where I got them. Reporting time is no longer a week of guesswork.',
  author: 'Karen Whitfield',
  role: 'Head of PE, Primary School — 21 years teaching',
  location: 'Brisbane, Australia'
}, {
  text: 'The emergency lesson kit saved me twice in the first fortnight — a flooded hall and a double class with no notice. I picked a no-equipment session, taught it, and the students never knew anything had changed. That confidence is worth far more than the price.',
  author: 'Ryan Doherty',
  role: 'PE Teacher, Middle Years — 4 years teaching',
  location: 'Manchester, United Kingdom'
}];
export function Testimonials() {
  return <section className="bg-brand-cream px-4 py-6 border-b border-brand-line" data-id="element-163" data-mp="1ohav0gjcqnpo">
      <div className="max-w-4xl mx-auto" data-id="element-164" data-mp="1ojf91rayt33o">
        <h2 className="font-display text-2xl sm:text-3xl text-brand-navy text-center mb-3" data-id="element-165" data-mp="1jir9uicl1fyd">
          What PE teachers are saying
        </h2>

        <div className="grid sm:grid-cols-2 gap-2.5" data-id="element-166" data-mp="1ekfy222q8vdi">
          {testimonials.map((t, i) => <figure key={t.author} className={`bg-white border border-brand-line rounded-xl p-3.5 shadow-sm flex flex-col ${i === 0 ? 'sm:col-span-2 border-l-4 border-l-brand-green' : ''}`} data-id="element-167" data-mp="19qv5wqntevm8" data-mpi={i}>
              <div className="flex gap-0.5 mb-1.5" role="img" aria-label="Rated 5 out of 5" data-id="element-168" data-mp="vswxs3037vf6">
                {[...Array(5)].map((_, s) => <StarIcon key={s} className="w-3.5 h-3.5 fill-brand-orange text-brand-orange" aria-hidden="true" data-id="element-169" data-mp="32fuixhzlm9gz" data-mpi={s} />)}
              </div>
              <blockquote className="text-[13px] sm:text-sm text-brand-slate font-medium italic leading-snug mb-2.5" data-id="element-170" data-mp="3cfv479h12znt">
                “{t.text}”
              </blockquote>
              <figcaption className="mt-auto border-t border-brand-line pt-2 flex items-center gap-2.5" data-id="element-171" data-mp="2jrh66tpxw3c9">
                <div className="w-8 h-8 rounded-full bg-brand-navy text-white font-display text-base flex items-center justify-center shrink-0" data-id="element-172" data-mp="2oqan6w4fqch6">
                  {t.author.charAt(0)}
                </div>
                <div className="leading-tight" data-id="element-173" data-mp="2xjdusnsefv3w">
                  <p className="font-heading font-bold text-[13px] text-brand-navy" data-id="element-174" data-mp="2106i0kblm4o2">
                    {t.author}
                  </p>
                  <p className="text-[10px] sm:text-[11px] text-brand-slate font-semibold uppercase tracking-wide" data-id="element-175" data-mp="25078528284ay">
                    {t.role} — {t.location}
                  </p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}